define(['jquery'], $ => {
    const API_URL = window.academieApiUrl;
    const SALON_SEARCH_ROUTE = window.academieSearchUrl;
    const BRAND = window.academieBrandName;
    const LIMIT = window.academieLimit;
    const additionalParams = window.additionalParams;

    return {
        API_URL,
        BRAND,
        SALON_SEARCH_ROUTE,
        LIMIT,

        getSalonsSearchUrl(params) {
            params = $.extend(
                {
                    brand: BRAND,
                    offset: 0,
                },
                additionalParams,
                params
            );

            return `${API_URL}${SALON_SEARCH_ROUTE}?${$.param(params)}`;
        },

        getSite: source =>
            (source || '').replace(/^(http|https):\/\/(нет|example.com)/, ''),

        getPhone: source => {
            source = source || '';

            if (source.length > 17) {
                source = source.split(',')[0];
            }

            return source;
        },

        getInstagram(source) {
            if (!source) {
                return '';
            }

            return source.split('https://instagram.com/')[1].replace('нет', '');
        },

        getVk: source => (source || '').replace('https://vk.com/нет', ''),

        getFacebook: source =>
            (source || '').replace('https://facebook.com/нет', ''),

        getOk: source => (source || '').replace('https://ok.ru/нет', ''),
    };
});
